import $ from 'jquery';
import DepricatedTerminalClass from './DepercatedTerminalClass';
import ImageDelayLoadManagerClass from '../../libs/load/ImageDelayLoadManagerClass';
import ParentClass from '../../libs/base/ParentClass';
import PartsManagerClass from './PartsManagerClass';
import RippleManagerClass from './RippleManagerClass';
import SvgDelayLoadManagerClass from '../../libs/load/SvgDelayLoadManagerClass';
import Util from '../../libs/util/Util';

/**
 * 全てのページクラスの元となるクラス
 */
export default class ParentPageBaseClass extends ParentClass {
  constructor(notImageLoaderFlg = false) {
    super();
    this.name = 'ParentPageBaseClass';

    document.addEventListener('DOMContentLoaded', () => {
      Util.isBreakpoint = $('html').attr('data-terminal_type') === 'sp';
      this.onCreate();
    });

    // イメージローダークラス不要の場合はロードしない
    if (notImageLoaderFlg == false) {
      window.addEventListener('load', () => {
        this.onLoad();
      });
    }

    this.things = {
      delayImg: new ImageDelayLoadManagerClass(),
      delaySvg: new SvgDelayLoadManagerClass(),
      ripple: new RippleManagerClass(),
      miscparts: new PartsManagerClass(),
      deprecatedTerm: new DepricatedTerminalClass(),
    };
  }

  onCreate() {
    super.onCreate();
    for (let k in this.things) { this.things[k].onCreate(); }
  }

  onLoad() {
    super.onLoad();
    for (let k in this.things) { this.things[k].onLoad(); }
  }

  onStop() {
    super.onStop();
    for (let k in this.things) { this.things[k].onStop(); }
  }

  onRemove() {
    super.onRemove();
    for (let k in this.things) { this.things[k].onRemove(); }
  }

  onResize(_size) {
    super.onResize(_size);
    for (let k in this.things) { this.things[k].onResize(_size); }
  }

  onScroll(_st) {
    super.onScroll();
    for (let k in this.things) { this.things[k].onScroll(_st); }
  }

  onImageLoadEnd() {
    super.onImageLoadEnd();
    for (let k in this.things) {
      this.things[k].isImageLoadEnd = true;
      this.things[k].onImageLoadEnd();
    }
    this.onResize(Util.getWindowSize());
    this.onScroll(Util.getScrollY());
  }

  mapReady() {
    for (let k in this.things) { this.things[k].mapReady(); }
    for (let k in this.parts) { this.parts[k].mapReady(); }
  }
}
